// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file protocol.proto (package river, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file protocol.proto.
 */
export const file_protocol = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty]);
/**
 * Describes the message river.Miniblock.
 * Use `create(MiniblockSchema)` to create a new message.
 */
export const MiniblockSchema = /*@__PURE__*/ messageDesc(file_protocol, 0);
/**
 * Describes the message river.Envelope.
 * Use `create(EnvelopeSchema)` to create a new message.
 */
export const EnvelopeSchema = /*@__PURE__*/ messageDesc(file_protocol, 1);
/**
 * Describes the message river.StreamEvent.
 * Use `create(StreamEventSchema)` to create a new message.
 */
export const StreamEventSchema = /*@__PURE__*/ messageDesc(file_protocol, 2);
/**
 * Describes the message river.MiniblockHeader.
 * Use `create(MiniblockHeaderSchema)` to create a new message.
 */
export const MiniblockHeaderSchema = /*@__PURE__*/ messageDesc(file_protocol, 3);
/**
 * Describes the message river.MemberPayload.
 * Use `create(MemberPayloadSchema)` to create a new message.
 */
export const MemberPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 4);
/**
 * Describes the message river.MemberPayload.Snapshot.
 * Use `create(MemberPayload_SnapshotSchema)` to create a new message.
 */
export const MemberPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 0);
/**
 * Describes the message river.MemberPayload.Snapshot.Member.
 * Use `create(MemberPayload_Snapshot_MemberSchema)` to create a new message.
 */
export const MemberPayload_Snapshot_MemberSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 0, 0);
/**
 * Describes the message river.MemberPayload.KeyPackage.
 * Use `create(MemberPayload_KeyPackageSchema)` to create a new message.
 */
export const MemberPayload_KeyPackageSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 1);
/**
 * Describes the message river.MemberPayload.Membership.
 * Use `create(MemberPayload_MembershipSchema)` to create a new message.
 */
export const MemberPayload_MembershipSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 2);
/**
 * Describes the message river.MemberPayload.KeySolicitation.
 * Use `create(MemberPayload_KeySolicitationSchema)` to create a new message.
 */
export const MemberPayload_KeySolicitationSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 3);
/**
 * Describes the message river.MemberPayload.KeyFulfillment.
 * Use `create(MemberPayload_KeyFulfillmentSchema)` to create a new message.
 */
export const MemberPayload_KeyFulfillmentSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 4);
/**
 * Describes the message river.MemberPayload.Nft.
 * Use `create(MemberPayload_NftSchema)` to create a new message.
 */
export const MemberPayload_NftSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 5);
/**
 * Describes the message river.MemberPayload.SnappedPin.
 * Use `create(MemberPayload_SnappedPinSchema)` to create a new message.
 */
export const MemberPayload_SnappedPinSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 6);
/**
 * Describes the message river.MemberPayload.Pin.
 * Use `create(MemberPayload_PinSchema)` to create a new message.
 */
export const MemberPayload_PinSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 7);
/**
 * Describes the message river.MemberPayload.Unpin.
 * Use `create(MemberPayload_UnpinSchema)` to create a new message.
 */
export const MemberPayload_UnpinSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 8);
/**
 * Describes the message river.MemberPayload.EncryptionAlgorithm.
 * Use `create(MemberPayload_EncryptionAlgorithmSchema)` to create a new message.
 */
export const MemberPayload_EncryptionAlgorithmSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 9);
/**
 * Describes the message river.MemberPayload.MemberBlockchainTransaction.
 * Use `create(MemberPayload_MemberBlockchainTransactionSchema)` to create a new message.
 */
export const MemberPayload_MemberBlockchainTransactionSchema = /*@__PURE__*/ messageDesc(file_protocol, 4, 10);
/**
 * Describes the message river.SpacePayload.
 * Use `create(SpacePayloadSchema)` to create a new message.
 */
export const SpacePayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 5);
/**
 * Describes the message river.SpacePayload.Snapshot.
 * Use `create(SpacePayload_SnapshotSchema)` to create a new message.
 */
export const SpacePayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 0);
/**
 * Describes the message river.SpacePayload.SnappedSpaceImage.
 * Use `create(SpacePayload_SnappedSpaceImageSchema)` to create a new message.
 */
export const SpacePayload_SnappedSpaceImageSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 1);
/**
 * Describes the message river.SpacePayload.Inception.
 * Use `create(SpacePayload_InceptionSchema)` to create a new message.
 */
export const SpacePayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 2);
/**
 * Describes the message river.SpacePayload.ChannelSettings.
 * Use `create(SpacePayload_ChannelSettingsSchema)` to create a new message.
 */
export const SpacePayload_ChannelSettingsSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 3);
/**
 * Describes the message river.SpacePayload.ChannelMetadata.
 * Use `create(SpacePayload_ChannelMetadataSchema)` to create a new message.
 */
export const SpacePayload_ChannelMetadataSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 4);
/**
 * Describes the message river.SpacePayload.ChannelUpdate.
 * Use `create(SpacePayload_ChannelUpdateSchema)` to create a new message.
 */
export const SpacePayload_ChannelUpdateSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 5);
/**
 * Describes the message river.SpacePayload.UpdateChannelAutojoin.
 * Use `create(SpacePayload_UpdateChannelAutojoinSchema)` to create a new message.
 */
export const SpacePayload_UpdateChannelAutojoinSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 6);
/**
 * Describes the message river.SpacePayload.UpdateChannelHideUserJoinLeaveEvents.
 * Use `create(SpacePayload_UpdateChannelHideUserJoinLeaveEventsSchema)` to create a new message.
 */
export const SpacePayload_UpdateChannelHideUserJoinLeaveEventsSchema = /*@__PURE__*/ messageDesc(file_protocol, 5, 7);
/**
 * Describes the message river.ChannelPayload.
 * Use `create(ChannelPayloadSchema)` to create a new message.
 */
export const ChannelPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 6);
/**
 * Describes the message river.ChannelPayload.Snapshot.
 * Use `create(ChannelPayload_SnapshotSchema)` to create a new message.
 */
export const ChannelPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 6, 0);
/**
 * Describes the message river.ChannelPayload.Inception.
 * Use `create(ChannelPayload_InceptionSchema)` to create a new message.
 */
export const ChannelPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 6, 1);
/**
 * Describes the message river.ChannelPayload.Redaction.
 * Use `create(ChannelPayload_RedactionSchema)` to create a new message.
 */
export const ChannelPayload_RedactionSchema = /*@__PURE__*/ messageDesc(file_protocol, 6, 2);
/**
 * Describes the message river.DmChannelPayload.
 * Use `create(DmChannelPayloadSchema)` to create a new message.
 */
export const DmChannelPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 7);
/**
 * Describes the message river.DmChannelPayload.Snapshot.
 * Use `create(DmChannelPayload_SnapshotSchema)` to create a new message.
 */
export const DmChannelPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 7, 0);
/**
 * Describes the message river.DmChannelPayload.Inception.
 * Use `create(DmChannelPayload_InceptionSchema)` to create a new message.
 */
export const DmChannelPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 7, 1);
/**
 * Describes the message river.GdmChannelPayload.
 * Use `create(GdmChannelPayloadSchema)` to create a new message.
 */
export const GdmChannelPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 8);
/**
 * Describes the message river.GdmChannelPayload.Snapshot.
 * Use `create(GdmChannelPayload_SnapshotSchema)` to create a new message.
 */
export const GdmChannelPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 8, 0);
/**
 * Describes the message river.GdmChannelPayload.Inception.
 * Use `create(GdmChannelPayload_InceptionSchema)` to create a new message.
 */
export const GdmChannelPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 8, 1);
/**
 * Describes the message river.UserPayload.
 * Use `create(UserPayloadSchema)` to create a new message.
 */
export const UserPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 9);
/**
 * Describes the message river.UserPayload.Snapshot.
 * Use `create(UserPayload_SnapshotSchema)` to create a new message.
 */
export const UserPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 9, 0);
/**
 * Describes the message river.UserPayload.Inception.
 * Use `create(UserPayload_InceptionSchema)` to create a new message.
 */
export const UserPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 9, 1);
/**
 * Describes the message river.UserPayload.UserMembership.
 * Use `create(UserPayload_UserMembershipSchema)` to create a new message.
 */
export const UserPayload_UserMembershipSchema = /*@__PURE__*/ messageDesc(file_protocol, 9, 2);
/**
 * Describes the message river.UserPayload.UserMembershipAction.
 * Use `create(UserPayload_UserMembershipActionSchema)` to create a new message.
 */
export const UserPayload_UserMembershipActionSchema = /*@__PURE__*/ messageDesc(file_protocol, 9, 3);
/**
 * Describes the message river.UserPayload.ReceivedBlockchainTransaction.
 * Use `create(UserPayload_ReceivedBlockchainTransactionSchema)` to create a new message.
 */
export const UserPayload_ReceivedBlockchainTransactionSchema = /*@__PURE__*/ messageDesc(file_protocol, 9, 4);
/**
 * Describes the message river.UserInboxPayload.
 * Use `create(UserInboxPayloadSchema)` to create a new message.
 */
export const UserInboxPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 10);
/**
 * Describes the message river.UserInboxPayload.Snapshot.
 * Use `create(UserInboxPayload_SnapshotSchema)` to create a new message.
 */
export const UserInboxPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 10, 0);
/**
 * Describes the message river.UserInboxPayload.Snapshot.DeviceSummary.
 * Use `create(UserInboxPayload_Snapshot_DeviceSummarySchema)` to create a new message.
 */
export const UserInboxPayload_Snapshot_DeviceSummarySchema = /*@__PURE__*/ messageDesc(file_protocol, 10, 0, 0);
/**
 * Describes the message river.UserInboxPayload.Inception.
 * Use `create(UserInboxPayload_InceptionSchema)` to create a new message.
 */
export const UserInboxPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 10, 1);
/**
 * Describes the message river.UserInboxPayload.GroupEncryptionSessions.
 * Use `create(UserInboxPayload_GroupEncryptionSessionsSchema)` to create a new message.
 */
export const UserInboxPayload_GroupEncryptionSessionsSchema = /*@__PURE__*/ messageDesc(file_protocol, 10, 2);
/**
 * Describes the message river.UserInboxPayload.Ack.
 * Use `create(UserInboxPayload_AckSchema)` to create a new message.
 */
export const UserInboxPayload_AckSchema = /*@__PURE__*/ messageDesc(file_protocol, 10, 3);
/**
 * Describes the message river.UserSettingsPayload.
 * Use `create(UserSettingsPayloadSchema)` to create a new message.
 */
export const UserSettingsPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 11);
/**
 * Describes the message river.UserSettingsPayload.Snapshot.
 * Use `create(UserSettingsPayload_SnapshotSchema)` to create a new message.
 */
export const UserSettingsPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 11, 0);
/**
 * Describes the message river.UserSettingsPayload.Snapshot.UserBlocks.
 * Use `create(UserSettingsPayload_Snapshot_UserBlocksSchema)` to create a new message.
 */
export const UserSettingsPayload_Snapshot_UserBlocksSchema = /*@__PURE__*/ messageDesc(file_protocol, 11, 0, 0);
/**
 * Describes the message river.UserSettingsPayload.Snapshot.UserBlocks.Block.
 * Use `create(UserSettingsPayload_Snapshot_UserBlocks_BlockSchema)` to create a new message.
 */
export const UserSettingsPayload_Snapshot_UserBlocks_BlockSchema = /*@__PURE__*/ messageDesc(file_protocol, 11, 0, 0, 0);
/**
 * Describes the message river.UserSettingsPayload.Inception.
 * Use `create(UserSettingsPayload_InceptionSchema)` to create a new message.
 */
export const UserSettingsPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 11, 1);
/**
 * Describes the message river.UserSettingsPayload.MarkerContent.
 * Use `create(UserSettingsPayload_MarkerContentSchema)` to create a new message.
 */
export const UserSettingsPayload_MarkerContentSchema = /*@__PURE__*/ messageDesc(file_protocol, 11, 2);
/**
 * Describes the message river.UserSettingsPayload.FullyReadMarkers.
 * Use `create(UserSettingsPayload_FullyReadMarkersSchema)` to create a new message.
 */
export const UserSettingsPayload_FullyReadMarkersSchema = /*@__PURE__*/ messageDesc(file_protocol, 11, 3);
/**
 * Describes the message river.UserSettingsPayload.UserBlock.
 * Use `create(UserSettingsPayload_UserBlockSchema)` to create a new message.
 */
export const UserSettingsPayload_UserBlockSchema = /*@__PURE__*/ messageDesc(file_protocol, 11, 4);
/**
 * Describes the message river.UserMetadataPayload.
 * Use `create(UserMetadataPayloadSchema)` to create a new message.
 */
export const UserMetadataPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 12);
/**
 * Describes the message river.UserMetadataPayload.Snapshot.
 * Use `create(UserMetadataPayload_SnapshotSchema)` to create a new message.
 */
export const UserMetadataPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 12, 0);
/**
 * Describes the message river.UserMetadataPayload.Inception.
 * Use `create(UserMetadataPayload_InceptionSchema)` to create a new message.
 */
export const UserMetadataPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 12, 1);
/**
 * Describes the message river.UserMetadataPayload.EncryptionDevice.
 * Use `create(UserMetadataPayload_EncryptionDeviceSchema)` to create a new message.
 */
export const UserMetadataPayload_EncryptionDeviceSchema = /*@__PURE__*/ messageDesc(file_protocol, 12, 2);
/**
 * Describes the message river.MediaPayload.
 * Use `create(MediaPayloadSchema)` to create a new message.
 */
export const MediaPayloadSchema = /*@__PURE__*/ messageDesc(file_protocol, 13);
/**
 * Describes the message river.MediaPayload.Snapshot.
 * Use `create(MediaPayload_SnapshotSchema)` to create a new message.
 */
export const MediaPayload_SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 13, 0);
/**
 * Describes the message river.MediaPayload.Inception.
 * Use `create(MediaPayload_InceptionSchema)` to create a new message.
 */
export const MediaPayload_InceptionSchema = /*@__PURE__*/ messageDesc(file_protocol, 13, 1);
/**
 * Describes the message river.MediaPayload.Chunk.
 * Use `create(MediaPayload_ChunkSchema)` to create a new message.
 */
export const MediaPayload_ChunkSchema = /*@__PURE__*/ messageDesc(file_protocol, 13, 2);
/**
 * Describes the message river.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema = /*@__PURE__*/ messageDesc(file_protocol, 14);
/**
 * Describes the message river.BlockchainTransaction.
 * Use `create(BlockchainTransactionSchema)` to create a new message.
 */
export const BlockchainTransactionSchema = /*@__PURE__*/ messageDesc(file_protocol, 15);
/**
 * Describes the message river.BlockchainTransaction.Tip.
 * Use `create(BlockchainTransaction_TipSchema)` to create a new message.
 */
export const BlockchainTransaction_TipSchema = /*@__PURE__*/ messageDesc(file_protocol, 15, 0);
/**
 * Describes the message river.BlockchainTransaction.Tip.Event.
 * Use `create(BlockchainTransaction_Tip_EventSchema)` to create a new message.
 */
export const BlockchainTransaction_Tip_EventSchema = /*@__PURE__*/ messageDesc(file_protocol, 15, 0, 0);
/**
 * Describes the message river.BlockchainTransaction.TokenTransfer.
 * Use `create(BlockchainTransaction_TokenTransferSchema)` to create a new message.
 */
export const BlockchainTransaction_TokenTransferSchema = /*@__PURE__*/ messageDesc(file_protocol, 15, 1);
/**
 * Describes the message river.BlockchainTransaction.SpaceReview.
 * Use `create(BlockchainTransaction_SpaceReviewSchema)` to create a new message.
 */
export const BlockchainTransaction_SpaceReviewSchema = /*@__PURE__*/ messageDesc(file_protocol, 15, 2);
/**
 * Describes the message river.BlockchainTransaction.SpaceReview.Event.
 * Use `create(BlockchainTransaction_SpaceReview_EventSchema)` to create a new message.
 */
export const BlockchainTransaction_SpaceReview_EventSchema = /*@__PURE__*/ messageDesc(file_protocol, 15, 2, 0);
/**
 * @generated from enum river.BlockchainTransaction.SpaceReview.Action
 */
export var BlockchainTransaction_SpaceReview_Action;
(function (BlockchainTransaction_SpaceReview_Action) {
    /**
     * @generated from enum value: Add = 0;
     */
    BlockchainTransaction_SpaceReview_Action[BlockchainTransaction_SpaceReview_Action["Add"] = 0] = "Add";
    /**
     * @generated from enum value: Update = 1;
     */
    BlockchainTransaction_SpaceReview_Action[BlockchainTransaction_SpaceReview_Action["Update"] = 1] = "Update";
    /**
     * @generated from enum value: Delete = 2;
     */
    BlockchainTransaction_SpaceReview_Action[BlockchainTransaction_SpaceReview_Action["Delete"] = 2] = "Delete";
})(BlockchainTransaction_SpaceReview_Action || (BlockchainTransaction_SpaceReview_Action = {}));
/**
 * Describes the enum river.BlockchainTransaction.SpaceReview.Action.
 */
export const BlockchainTransaction_SpaceReview_ActionSchema = /*@__PURE__*/ enumDesc(file_protocol, 15, 2, 0);
/**
 * Describes the message river.BlockchainTransactionReceipt.
 * Use `create(BlockchainTransactionReceiptSchema)` to create a new message.
 */
export const BlockchainTransactionReceiptSchema = /*@__PURE__*/ messageDesc(file_protocol, 16);
/**
 * Describes the message river.BlockchainTransactionReceipt.Log.
 * Use `create(BlockchainTransactionReceipt_LogSchema)` to create a new message.
 */
export const BlockchainTransactionReceipt_LogSchema = /*@__PURE__*/ messageDesc(file_protocol, 16, 0);
/**
 * Describes the message river.SolanaBlockchainTransactionReceipt.
 * Use `create(SolanaBlockchainTransactionReceiptSchema)` to create a new message.
 */
export const SolanaBlockchainTransactionReceiptSchema = /*@__PURE__*/ messageDesc(file_protocol, 17);
/**
 * Describes the message river.SolanaBlockchainTransactionReceipt.Transaction.
 * Use `create(SolanaBlockchainTransactionReceipt_TransactionSchema)` to create a new message.
 */
export const SolanaBlockchainTransactionReceipt_TransactionSchema = /*@__PURE__*/ messageDesc(file_protocol, 17, 0);
/**
 * Describes the message river.SolanaBlockchainTransactionReceipt.Meta.
 * Use `create(SolanaBlockchainTransactionReceipt_MetaSchema)` to create a new message.
 */
export const SolanaBlockchainTransactionReceipt_MetaSchema = /*@__PURE__*/ messageDesc(file_protocol, 17, 1);
/**
 * Describes the message river.SolanaBlockchainTransactionReceipt.Meta.TokenBalance.
 * Use `create(SolanaBlockchainTransactionReceipt_Meta_TokenBalanceSchema)` to create a new message.
 */
export const SolanaBlockchainTransactionReceipt_Meta_TokenBalanceSchema = /*@__PURE__*/ messageDesc(file_protocol, 17, 1, 0);
/**
 * Describes the message river.SolanaBlockchainTransactionReceipt.Meta.TokenBalance.UITokenAmount.
 * Use `create(SolanaBlockchainTransactionReceipt_Meta_TokenBalance_UITokenAmountSchema)` to create a new message.
 */
export const SolanaBlockchainTransactionReceipt_Meta_TokenBalance_UITokenAmountSchema = /*@__PURE__*/ messageDesc(file_protocol, 17, 1, 0, 0);
/**
 * Describes the message river.EventRef.
 * Use `create(EventRefSchema)` to create a new message.
 */
export const EventRefSchema = /*@__PURE__*/ messageDesc(file_protocol, 18);
/**
 * Describes the message river.StreamSettings.
 * Use `create(StreamSettingsSchema)` to create a new message.
 */
export const StreamSettingsSchema = /*@__PURE__*/ messageDesc(file_protocol, 19);
/**
 * Describes the message river.EncryptedData.
 * Use `create(EncryptedDataSchema)` to create a new message.
 */
export const EncryptedDataSchema = /*@__PURE__*/ messageDesc(file_protocol, 20);
/**
 * Describes the message river.WrappedEncryptedData.
 * Use `create(WrappedEncryptedDataSchema)` to create a new message.
 */
export const WrappedEncryptedDataSchema = /*@__PURE__*/ messageDesc(file_protocol, 21);
/**
 * Describes the message river.SyncCookie.
 * Use `create(SyncCookieSchema)` to create a new message.
 */
export const SyncCookieSchema = /*@__PURE__*/ messageDesc(file_protocol, 22);
/**
 * Describes the message river.CreationCookie.
 * Use `create(CreationCookieSchema)` to create a new message.
 */
export const CreationCookieSchema = /*@__PURE__*/ messageDesc(file_protocol, 23);
/**
 * Describes the message river.StreamAndCookie.
 * Use `create(StreamAndCookieSchema)` to create a new message.
 */
export const StreamAndCookieSchema = /*@__PURE__*/ messageDesc(file_protocol, 24);
/**
 * Describes the message river.Minipool.
 * Use `create(MinipoolSchema)` to create a new message.
 */
export const MinipoolSchema = /*@__PURE__*/ messageDesc(file_protocol, 25);
/**
 * Describes the message river.Tags.
 * Use `create(TagsSchema)` to create a new message.
 */
export const TagsSchema = /*@__PURE__*/ messageDesc(file_protocol, 26);
/**
 * Describes the message river.InfoRequest.
 * Use `create(InfoRequestSchema)` to create a new message.
 */
export const InfoRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 27);
/**
 * Describes the message river.InfoResponse.
 * Use `create(InfoResponseSchema)` to create a new message.
 */
export const InfoResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 28);
/**
 * Describes the message river.GetStreamExRequest.
 * Use `create(GetStreamExRequestSchema)` to create a new message.
 */
export const GetStreamExRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 29);
/**
 * Describes the message river.GetStreamExResponse.
 * Use `create(GetStreamExResponseSchema)` to create a new message.
 */
export const GetStreamExResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 30);
/**
 * Describes the message river.CreateStreamRequest.
 * Use `create(CreateStreamRequestSchema)` to create a new message.
 */
export const CreateStreamRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 31);
/**
 * Describes the message river.CreateStreamResponse.
 * Use `create(CreateStreamResponseSchema)` to create a new message.
 */
export const CreateStreamResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 32);
/**
 * Describes the message river.CreateMediaStreamRequest.
 * Use `create(CreateMediaStreamRequestSchema)` to create a new message.
 */
export const CreateMediaStreamRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 33);
/**
 * Describes the message river.CreateMediaStreamResponse.
 * Use `create(CreateMediaStreamResponseSchema)` to create a new message.
 */
export const CreateMediaStreamResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 34);
/**
 * Describes the message river.GetStreamRequest.
 * Use `create(GetStreamRequestSchema)` to create a new message.
 */
export const GetStreamRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 35);
/**
 * Describes the message river.GetStreamResponse.
 * Use `create(GetStreamResponseSchema)` to create a new message.
 */
export const GetStreamResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 36);
/**
 * Describes the message river.GetMiniblocksRequest.
 * Use `create(GetMiniblocksRequestSchema)` to create a new message.
 */
export const GetMiniblocksRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 37);
/**
 * Describes the message river.GetMiniblocksResponse.
 * Use `create(GetMiniblocksResponseSchema)` to create a new message.
 */
export const GetMiniblocksResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 38);
/**
 * Describes the message river.GetLastMiniblockHashRequest.
 * Use `create(GetLastMiniblockHashRequestSchema)` to create a new message.
 */
export const GetLastMiniblockHashRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 39);
/**
 * Describes the message river.GetLastMiniblockHashResponse.
 * Use `create(GetLastMiniblockHashResponseSchema)` to create a new message.
 */
export const GetLastMiniblockHashResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 40);
/**
 * Describes the message river.AddEventRequest.
 * Use `create(AddEventRequestSchema)` to create a new message.
 */
export const AddEventRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 41);
/**
 * Describes the message river.AddEventResponse.
 * Use `create(AddEventResponseSchema)` to create a new message.
 */
export const AddEventResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 42);
/**
 * Describes the message river.AddEventResponse.Error.
 * Use `create(AddEventResponse_ErrorSchema)` to create a new message.
 */
export const AddEventResponse_ErrorSchema = /*@__PURE__*/ messageDesc(file_protocol, 42, 0);
/**
 * Describes the message river.AddMediaEventRequest.
 * Use `create(AddMediaEventRequestSchema)` to create a new message.
 */
export const AddMediaEventRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 43);
/**
 * Describes the message river.AddMediaEventResponse.
 * Use `create(AddMediaEventResponseSchema)` to create a new message.
 */
export const AddMediaEventResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 44);
/**
 * Describes the message river.SyncStreamsRequest.
 * Use `create(SyncStreamsRequestSchema)` to create a new message.
 */
export const SyncStreamsRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 45);
/**
 * Describes the message river.SyncStreamsResponse.
 * Use `create(SyncStreamsResponseSchema)` to create a new message.
 */
export const SyncStreamsResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 46);
/**
 * Describes the message river.AddStreamToSyncRequest.
 * Use `create(AddStreamToSyncRequestSchema)` to create a new message.
 */
export const AddStreamToSyncRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 47);
/**
 * Describes the message river.AddStreamToSyncResponse.
 * Use `create(AddStreamToSyncResponseSchema)` to create a new message.
 */
export const AddStreamToSyncResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 48);
/**
 * Describes the message river.RemoveStreamFromSyncRequest.
 * Use `create(RemoveStreamFromSyncRequestSchema)` to create a new message.
 */
export const RemoveStreamFromSyncRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 49);
/**
 * Describes the message river.RemoveStreamFromSyncResponse.
 * Use `create(RemoveStreamFromSyncResponseSchema)` to create a new message.
 */
export const RemoveStreamFromSyncResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 50);
/**
 * Describes the message river.ModifySyncRequest.
 * Use `create(ModifySyncRequestSchema)` to create a new message.
 */
export const ModifySyncRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 51);
/**
 * Describes the message river.SyncStreamOpStatus.
 * Use `create(SyncStreamOpStatusSchema)` to create a new message.
 */
export const SyncStreamOpStatusSchema = /*@__PURE__*/ messageDesc(file_protocol, 52);
/**
 * Describes the message river.ModifySyncResponse.
 * Use `create(ModifySyncResponseSchema)` to create a new message.
 */
export const ModifySyncResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 53);
/**
 * Describes the message river.CancelSyncRequest.
 * Use `create(CancelSyncRequestSchema)` to create a new message.
 */
export const CancelSyncRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 54);
/**
 * Describes the message river.CancelSyncResponse.
 * Use `create(CancelSyncResponseSchema)` to create a new message.
 */
export const CancelSyncResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 55);
/**
 * Describes the message river.PingSyncRequest.
 * Use `create(PingSyncRequestSchema)` to create a new message.
 */
export const PingSyncRequestSchema = /*@__PURE__*/ messageDesc(file_protocol, 56);
/**
 * Describes the message river.PingSyncResponse.
 * Use `create(PingSyncResponseSchema)` to create a new message.
 */
export const PingSyncResponseSchema = /*@__PURE__*/ messageDesc(file_protocol, 57);
/**
 * @generated from enum river.SyncOp
 */
export var SyncOp;
(function (SyncOp) {
    /**
     * @generated from enum value: SYNC_UNSPECIFIED = 0;
     */
    SyncOp[SyncOp["SYNC_UNSPECIFIED"] = 0] = "SYNC_UNSPECIFIED";
    /**
     * new sync
     *
     * @generated from enum value: SYNC_NEW = 1;
     */
    SyncOp[SyncOp["SYNC_NEW"] = 1] = "SYNC_NEW";
    /**
     * close the sync
     *
     * @generated from enum value: SYNC_CLOSE = 2;
     */
    SyncOp[SyncOp["SYNC_CLOSE"] = 2] = "SYNC_CLOSE";
    /**
     * update from server
     *
     * @generated from enum value: SYNC_UPDATE = 3;
     */
    SyncOp[SyncOp["SYNC_UPDATE"] = 3] = "SYNC_UPDATE";
    /**
     * respond to the ping message from the client.
     *
     * @generated from enum value: SYNC_PONG = 4;
     */
    SyncOp[SyncOp["SYNC_PONG"] = 4] = "SYNC_PONG";
    /**
     * indication that stream updates could (temporarily) not be provided
     *
     * @generated from enum value: SYNC_DOWN = 5;
     */
    SyncOp[SyncOp["SYNC_DOWN"] = 5] = "SYNC_DOWN";
})(SyncOp || (SyncOp = {}));
/**
 * Describes the enum river.SyncOp.
 */
export const SyncOpSchema = /*@__PURE__*/ enumDesc(file_protocol, 0);
/**
 * @generated from enum river.MembershipOp
 */
export var MembershipOp;
(function (MembershipOp) {
    /**
     * @generated from enum value: SO_UNSPECIFIED = 0;
     */
    MembershipOp[MembershipOp["SO_UNSPECIFIED"] = 0] = "SO_UNSPECIFIED";
    /**
     * @generated from enum value: SO_INVITE = 1;
     */
    MembershipOp[MembershipOp["SO_INVITE"] = 1] = "SO_INVITE";
    /**
     * @generated from enum value: SO_JOIN = 2;
     */
    MembershipOp[MembershipOp["SO_JOIN"] = 2] = "SO_JOIN";
    /**
     * @generated from enum value: SO_LEAVE = 3;
     */
    MembershipOp[MembershipOp["SO_LEAVE"] = 3] = "SO_LEAVE";
})(MembershipOp || (MembershipOp = {}));
/**
 * Describes the enum river.MembershipOp.
 */
export const MembershipOpSchema = /*@__PURE__*/ enumDesc(file_protocol, 1);
/**
 * @generated from enum river.ChannelOp
 */
export var ChannelOp;
(function (ChannelOp) {
    /**
     * @generated from enum value: CO_UNSPECIFIED = 0;
     */
    ChannelOp[ChannelOp["CO_UNSPECIFIED"] = 0] = "CO_UNSPECIFIED";
    /**
     * @generated from enum value: CO_CREATED = 1;
     */
    ChannelOp[ChannelOp["CO_CREATED"] = 1] = "CO_CREATED";
    /**
     * @generated from enum value: CO_DELETED = 2;
     */
    ChannelOp[ChannelOp["CO_DELETED"] = 2] = "CO_DELETED";
    /**
     * @generated from enum value: CO_UPDATED = 4;
     */
    ChannelOp[ChannelOp["CO_UPDATED"] = 4] = "CO_UPDATED";
})(ChannelOp || (ChannelOp = {}));
/**
 * Describes the enum river.ChannelOp.
 */
export const ChannelOpSchema = /*@__PURE__*/ enumDesc(file_protocol, 2);
/**
 * @generated from enum river.MessageInteractionType
 */
export var MessageInteractionType;
(function (MessageInteractionType) {
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_UNSPECIFIED = 0;
     */
    MessageInteractionType[MessageInteractionType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_REPLY = 1;
     */
    MessageInteractionType[MessageInteractionType["REPLY"] = 1] = "REPLY";
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_REACTION = 2;
     */
    MessageInteractionType[MessageInteractionType["REACTION"] = 2] = "REACTION";
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_POST = 3;
     */
    MessageInteractionType[MessageInteractionType["POST"] = 3] = "POST";
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_EDIT = 4;
     */
    MessageInteractionType[MessageInteractionType["EDIT"] = 4] = "EDIT";
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_REDACTION = 5;
     */
    MessageInteractionType[MessageInteractionType["REDACTION"] = 5] = "REDACTION";
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_TIP = 6;
     */
    MessageInteractionType[MessageInteractionType["TIP"] = 6] = "TIP";
    /**
     * @generated from enum value: MESSAGE_INTERACTION_TYPE_TRADE = 7;
     */
    MessageInteractionType[MessageInteractionType["TRADE"] = 7] = "TRADE";
})(MessageInteractionType || (MessageInteractionType = {}));
/**
 * Describes the enum river.MessageInteractionType.
 */
export const MessageInteractionTypeSchema = /*@__PURE__*/ enumDesc(file_protocol, 3);
/**
 * @generated from enum river.GroupMentionType
 */
export var GroupMentionType;
(function (GroupMentionType) {
    /**
     * @generated from enum value: GROUP_MENTION_TYPE_UNSPECIFIED = 0;
     */
    GroupMentionType[GroupMentionType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: GROUP_MENTION_TYPE_AT_CHANNEL = 1;
     */
    GroupMentionType[GroupMentionType["AT_CHANNEL"] = 1] = "AT_CHANNEL";
})(GroupMentionType || (GroupMentionType = {}));
/**
 * Describes the enum river.GroupMentionType.
 */
export const GroupMentionTypeSchema = /*@__PURE__*/ enumDesc(file_protocol, 4);
/**
 * @generated from enum river.EncryptedDataVersion
 */
export var EncryptedDataVersion;
(function (EncryptedDataVersion) {
    /**
     * @generated from enum value: ENCRYPTED_DATA_VERSION_0 = 0;
     */
    EncryptedDataVersion[EncryptedDataVersion["ENCRYPTED_DATA_VERSION_0"] = 0] = "ENCRYPTED_DATA_VERSION_0";
    /**
     * @generated from enum value: ENCRYPTED_DATA_VERSION_1 = 1;
     */
    EncryptedDataVersion[EncryptedDataVersion["ENCRYPTED_DATA_VERSION_1"] = 1] = "ENCRYPTED_DATA_VERSION_1";
})(EncryptedDataVersion || (EncryptedDataVersion = {}));
/**
 * Describes the enum river.EncryptedDataVersion.
 */
export const EncryptedDataVersionSchema = /*@__PURE__*/ enumDesc(file_protocol, 5);
/**
 * Codes from 1 to 16 match gRPC/Connect codes.
 *
 * @generated from enum river.Err
 */
export var Err;
(function (Err) {
    /**
     * @generated from enum value: ERR_UNSPECIFIED = 0;
     */
    Err[Err["ERR_UNSPECIFIED"] = 0] = "ERR_UNSPECIFIED";
    /**
     * Canceled indicates that the operation was canceled, typically by the
     * caller.
     *
     * @generated from enum value: CANCELED = 1;
     */
    Err[Err["CANCELED"] = 1] = "CANCELED";
    /**
     * Unknown indicates that the operation failed for an unknown reason.
     *
     * @generated from enum value: UNKNOWN = 2;
     */
    Err[Err["UNKNOWN"] = 2] = "UNKNOWN";
    /**
     * InvalidArgument indicates that client supplied an invalid argument.
     *
     * @generated from enum value: INVALID_ARGUMENT = 3;
     */
    Err[Err["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    /**
     * DeadlineExceeded indicates that deadline expired before the operation
     * could complete.
     *
     * @generated from enum value: DEADLINE_EXCEEDED = 4;
     */
    Err[Err["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    /**
     * NotFound indicates that some requested entity (for example, a file or
     * directory) was not found.
     *
     * @generated from enum value: NOT_FOUND = 5;
     */
    Err[Err["NOT_FOUND"] = 5] = "NOT_FOUND";
    /**
     * AlreadyExists indicates that client attempted to create an entity (for
     * example, a file or directory) that already exists.
     *
     * @generated from enum value: ALREADY_EXISTS = 6;
     */
    Err[Err["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    /**
     * PermissionDenied indicates that the caller doesn't have permission to
     * execute the specified operation.
     *
     * @generated from enum value: PERMISSION_DENIED = 7;
     */
    Err[Err["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    /**
     * ResourceExhausted indicates that some resource has been exhausted. For
     * example, a per-user quota may be exhausted or the entire file system may
     * be full.
     *
     * @generated from enum value: RESOURCE_EXHAUSTED = 8;
     */
    Err[Err["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    /**
     * FailedPrecondition indicates that the system is not in a state
     * required for the operation's execution.
     *
     * @generated from enum value: FAILED_PRECONDITION = 9;
     */
    Err[Err["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    /**
     * Aborted indicates that operation was aborted by the system, usually
     * because of a concurrency issue such as a sequencer check failure or
     * transaction abort.
     *
     * @generated from enum value: ABORTED = 10;
     */
    Err[Err["ABORTED"] = 10] = "ABORTED";
    /**
     * OutOfRange indicates that the operation was attempted past the valid
     * range (for example, seeking past end-of-file).
     *
     * @generated from enum value: OUT_OF_RANGE = 11;
     */
    Err[Err["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    /**
     * Unimplemented indicates that the operation isn't implemented,
     * supported, or enabled in this service.
     *
     * @generated from enum value: UNIMPLEMENTED = 12;
     */
    Err[Err["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    /**
     * Internal indicates that some invariants expected by the underlying
     * system have been broken. This code is reserved for serious errors.
     *
     * @generated from enum value: INTERNAL = 13;
     */
    Err[Err["INTERNAL"] = 13] = "INTERNAL";
    /**
     * Unavailable indicates that the service is currently unavailable. This
     * is usually temporary, so clients can back off and retry idempotent
     * operations.
     *
     * @generated from enum value: UNAVAILABLE = 14;
     */
    Err[Err["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    /**
     * DataLoss indicates that the operation has resulted in unrecoverable
     * data loss or corruption.
     *
     * @generated from enum value: DATA_LOSS = 15;
     */
    Err[Err["DATA_LOSS"] = 15] = "DATA_LOSS";
    /**
     * Unauthenticated indicates that the request does not have valid
     * authentication credentials for the operation.
     *
     * @generated from enum value: UNAUTHENTICATED = 16;
     */
    Err[Err["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
    /**
     * @generated from enum value: DEBUG_ERROR = 17;
     */
    Err[Err["DEBUG_ERROR"] = 17] = "DEBUG_ERROR";
    /**
     * @generated from enum value: BAD_STREAM_ID = 18;
     */
    Err[Err["BAD_STREAM_ID"] = 18] = "BAD_STREAM_ID";
    /**
     * @generated from enum value: BAD_STREAM_CREATION_PARAMS = 19;
     */
    Err[Err["BAD_STREAM_CREATION_PARAMS"] = 19] = "BAD_STREAM_CREATION_PARAMS";
    /**
     * @generated from enum value: INTERNAL_ERROR_SWITCH = 20;
     */
    Err[Err["INTERNAL_ERROR_SWITCH"] = 20] = "INTERNAL_ERROR_SWITCH";
    /**
     * @generated from enum value: BAD_EVENT_ID = 21;
     */
    Err[Err["BAD_EVENT_ID"] = 21] = "BAD_EVENT_ID";
    /**
     * @generated from enum value: BAD_EVENT_SIGNATURE = 22;
     */
    Err[Err["BAD_EVENT_SIGNATURE"] = 22] = "BAD_EVENT_SIGNATURE";
    /**
     * @generated from enum value: BAD_HASH_FORMAT = 23;
     */
    Err[Err["BAD_HASH_FORMAT"] = 23] = "BAD_HASH_FORMAT";
    /**
     * @generated from enum value: BAD_PREV_MINIBLOCK_HASH = 24;
     */
    Err[Err["BAD_PREV_MINIBLOCK_HASH"] = 24] = "BAD_PREV_MINIBLOCK_HASH";
    /**
     * @generated from enum value: NO_EVENT_SPECIFIED = 25;
     */
    Err[Err["NO_EVENT_SPECIFIED"] = 25] = "NO_EVENT_SPECIFIED";
    /**
     * @generated from enum value: BAD_EVENT = 26;
     */
    Err[Err["BAD_EVENT"] = 26] = "BAD_EVENT";
    /**
     * @generated from enum value: USER_CANT_POST = 27;
     */
    Err[Err["USER_CANT_POST"] = 27] = "USER_CANT_POST";
    /**
     * @generated from enum value: STREAM_BAD_HASHES = 28;
     */
    Err[Err["STREAM_BAD_HASHES"] = 28] = "STREAM_BAD_HASHES";
    /**
     * @generated from enum value: STREAM_EMPTY = 29;
     */
    Err[Err["STREAM_EMPTY"] = 29] = "STREAM_EMPTY";
    /**
     * @generated from enum value: STREAM_BAD_EVENT = 30;
     */
    Err[Err["STREAM_BAD_EVENT"] = 30] = "STREAM_BAD_EVENT";
    /**
     * @generated from enum value: BAD_DELEGATE_SIG = 31;
     */
    Err[Err["BAD_DELEGATE_SIG"] = 31] = "BAD_DELEGATE_SIG";
    /**
     * @generated from enum value: BAD_PUBLIC_KEY = 32;
     */
    Err[Err["BAD_PUBLIC_KEY"] = 32] = "BAD_PUBLIC_KEY";
    /**
     * @generated from enum value: BAD_PAYLOAD = 33;
     */
    Err[Err["BAD_PAYLOAD"] = 33] = "BAD_PAYLOAD";
    /**
     * @generated from enum value: BAD_HEX_STRING = 34;
     */
    Err[Err["BAD_HEX_STRING"] = 34] = "BAD_HEX_STRING";
    /**
     * @generated from enum value: BAD_EVENT_HASH = 35;
     */
    Err[Err["BAD_EVENT_HASH"] = 35] = "BAD_EVENT_HASH";
    /**
     * @generated from enum value: BAD_SYNC_COOKIE = 36;
     */
    Err[Err["BAD_SYNC_COOKIE"] = 36] = "BAD_SYNC_COOKIE";
    /**
     * @generated from enum value: DUPLICATE_EVENT = 37;
     */
    Err[Err["DUPLICATE_EVENT"] = 37] = "DUPLICATE_EVENT";
    /**
     * @generated from enum value: BAD_BLOCK = 38;
     */
    Err[Err["BAD_BLOCK"] = 38] = "BAD_BLOCK";
    /**
     * @generated from enum value: STREAM_NO_INCEPTION_EVENT = 39;
     */
    Err[Err["STREAM_NO_INCEPTION_EVENT"] = 39] = "STREAM_NO_INCEPTION_EVENT";
    /**
     * @generated from enum value: BAD_BLOCK_NUMBER = 40;
     */
    Err[Err["BAD_BLOCK_NUMBER"] = 40] = "BAD_BLOCK_NUMBER";
    /**
     * @generated from enum value: BAD_MINIPOOL_SLOT = 41;
     */
    Err[Err["BAD_MINIPOOL_SLOT"] = 41] = "BAD_MINIPOOL_SLOT";
    /**
     * @generated from enum value: BAD_CREATOR_ADDRESS = 42;
     */
    Err[Err["BAD_CREATOR_ADDRESS"] = 42] = "BAD_CREATOR_ADDRESS";
    /**
     * @generated from enum value: STALE_DELEGATE = 43;
     */
    Err[Err["STALE_DELEGATE"] = 43] = "STALE_DELEGATE";
    /**
     * @generated from enum value: BAD_LINK_WALLET_BAD_SIGNATURE = 44;
     */
    Err[Err["BAD_LINK_WALLET_BAD_SIGNATURE"] = 44] = "BAD_LINK_WALLET_BAD_SIGNATURE";
    /**
     * @generated from enum value: BAD_ROOT_KEY_ID = 45;
     */
    Err[Err["BAD_ROOT_KEY_ID"] = 45] = "BAD_ROOT_KEY_ID";
    /**
     * @generated from enum value: UNKNOWN_NODE = 46;
     */
    Err[Err["UNKNOWN_NODE"] = 46] = "UNKNOWN_NODE";
    /**
     * @generated from enum value: DB_OPERATION_FAILURE = 47;
     */
    Err[Err["DB_OPERATION_FAILURE"] = 47] = "DB_OPERATION_FAILURE";
    /**
     * @generated from enum value: MINIBLOCKS_STORAGE_FAILURE = 48;
     */
    Err[Err["MINIBLOCKS_STORAGE_FAILURE"] = 48] = "MINIBLOCKS_STORAGE_FAILURE";
    /**
     * @generated from enum value: BAD_ADDRESS = 49;
     */
    Err[Err["BAD_ADDRESS"] = 49] = "BAD_ADDRESS";
    /**
     * @generated from enum value: BUFFER_FULL = 50;
     */
    Err[Err["BUFFER_FULL"] = 50] = "BUFFER_FULL";
    /**
     * @generated from enum value: BAD_CONFIG = 51;
     */
    Err[Err["BAD_CONFIG"] = 51] = "BAD_CONFIG";
    /**
     * @generated from enum value: BAD_CONTRACT = 52;
     */
    Err[Err["BAD_CONTRACT"] = 52] = "BAD_CONTRACT";
    /**
     * @generated from enum value: CANNOT_CONNECT = 53;
     */
    Err[Err["CANNOT_CONNECT"] = 53] = "CANNOT_CONNECT";
    /**
     * @generated from enum value: CANNOT_GET_LINKED_WALLETS = 54;
     */
    Err[Err["CANNOT_GET_LINKED_WALLETS"] = 54] = "CANNOT_GET_LINKED_WALLETS";
    /**
     * @generated from enum value: CANNOT_CHECK_ENTITLEMENTS = 55;
     */
    Err[Err["CANNOT_CHECK_ENTITLEMENTS"] = 55] = "CANNOT_CHECK_ENTITLEMENTS";
    /**
     * @generated from enum value: CANNOT_CALL_CONTRACT = 56;
     */
    Err[Err["CANNOT_CALL_CONTRACT"] = 56] = "CANNOT_CALL_CONTRACT";
    /**
     * @generated from enum value: SPACE_DISABLED = 57;
     */
    Err[Err["SPACE_DISABLED"] = 57] = "SPACE_DISABLED";
    /**
     * @generated from enum value: CHANNEL_DISABLED = 58;
     */
    Err[Err["CHANNEL_DISABLED"] = 58] = "CHANNEL_DISABLED";
    /**
     * @generated from enum value: WRONG_STREAM_TYPE = 59;
     */
    Err[Err["WRONG_STREAM_TYPE"] = 59] = "WRONG_STREAM_TYPE";
    /**
     * @generated from enum value: MINIPOOL_MISSING_EVENTS = 60;
     */
    Err[Err["MINIPOOL_MISSING_EVENTS"] = 60] = "MINIPOOL_MISSING_EVENTS";
    /**
     * @generated from enum value: STREAM_LAST_BLOCK_MISMATCH = 61;
     */
    Err[Err["STREAM_LAST_BLOCK_MISMATCH"] = 61] = "STREAM_LAST_BLOCK_MISMATCH";
    /**
     * @generated from enum value: DOWNSTREAM_NETWORK_ERROR = 62;
     */
    Err[Err["DOWNSTREAM_NETWORK_ERROR"] = 62] = "DOWNSTREAM_NETWORK_ERROR";
    /**
     * Stream replica on the local node does not have miniblock with given number yet.
     * This is a temporary state and the node will have the miniblock at a later point in time.
     * The client should retry with an increasing delay, starting at 100ms.
     *
     * @generated from enum value: MINIBLOCK_TOO_NEW = 63;
     */
    Err[Err["MINIBLOCK_TOO_NEW"] = 63] = "MINIBLOCK_TOO_NEW";
    /**
     * Stream replica on the local node already has a miniblock with the requested
     * proposal number.
     *
     * @generated from enum value: MINIBLOCK_TOO_OLD = 64;
     */
    Err[Err["MINIBLOCK_TOO_OLD"] = 64] = "MINIBLOCK_TOO_OLD";
    /**
     * Quorum failed to be reached for write operation.
     *
     * @generated from enum value: QUORUM_FAILED = 65;
     */
    Err[Err["QUORUM_FAILED"] = 65] = "QUORUM_FAILED";
    /**
     * App webhook could not successfully be called.
     *
     * @generated from enum value: CANNOT_CALL_WEBHOOK = 66;
     */
    Err[Err["CANNOT_CALL_WEBHOOK"] = 66] = "CANNOT_CALL_WEBHOOK";
    /**
     * App webhook response was unparsable as JSON or did not match expected schema.
     *
     * @generated from enum value: MALFORMED_WEBHOOK_RESPONSE = 67;
     */
    Err[Err["MALFORMED_WEBHOOK_RESPONSE"] = 67] = "MALFORMED_WEBHOOK_RESPONSE";
    /**
     * The encryption device returned by the app service webhook does not match the first
     * encryption device found in the app's user metadata stream.
     *
     * @generated from enum value: BAD_ENCRYPTION_DEVICE = 68;
     */
    Err[Err["BAD_ENCRYPTION_DEVICE"] = 68] = "BAD_ENCRYPTION_DEVICE";
    /**
     * STREAM_RECONCILIATION_REQUIRED indicates that the stream is out of sync and must be
     * reconciled before it can be used.
     *
     * @generated from enum value: STREAM_RECONCILIATION_REQUIRED = 69;
     */
    Err[Err["STREAM_RECONCILIATION_REQUIRED"] = 69] = "STREAM_RECONCILIATION_REQUIRED";
})(Err || (Err = {}));
/**
 * Describes the enum river.Err.
 */
export const ErrSchema = /*@__PURE__*/ enumDesc(file_protocol, 6);
/**
 * @generated from service river.StreamService
 */
export const StreamService = /*@__PURE__*/ serviceDesc(file_protocol, 0);
//# sourceMappingURL=protocol_pb.js.map